<template>
  <div>
    <patent-list></patent-list>
  </div>
</template>

<script>

export default {
}
</script>



